"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogMessages = exports.ProgressMessages = exports.ProgressTitles = void 0;
const localizeUtils_1 = require("../common/localizeUtils");
class ProgressTitles {
}
exports.ProgressTitles = ProgressTitles;
ProgressTitles.create = localizeUtils_1.getLocalizedString("core.progress.create");
class ProgressMessages {
}
exports.ProgressMessages = ProgressMessages;
ProgressMessages.generateTemplate = localizeUtils_1.getLocalizedString("core.progress.createFromTemplate");
ProgressMessages.generateSample = (sampleName) => localizeUtils_1.getLocalizedString("core.progress.createFromSample", sampleName);
ProgressMessages.configureAzureStorageEnableStaticWebsite = localizeUtils_1.getLocalizedString("core.progress.configureAzureStorage");
ProgressMessages.runCommand = (command, directory) => localizeUtils_1.getLocalizedString("core.progress.runCommand", command, directory);
ProgressMessages.deployToAzure = (location, dist) => localizeUtils_1.getLocalizedString("core.progress.deployToAzure", location, dist);
class LogMessages {
}
exports.LogMessages = LogMessages;
LogMessages.getTemplateFromLocal = localizeUtils_1.getLocalizedString("plugins.function.getTemplateFromLocal");
//# sourceMappingURL=messages.js.map